import currency from "currency-formatter";

export function dollars(decimal, precision = 2, displayBlank = false) {
  if (displayBlank && !decimal) {
    return null;
  }

  const amount = decimal || 0;
  return currency.format(amount, { code: "USD", precision });
}

export function calculateCost(qty, costUnit) {
  return dollars(parseFloat(qty) * parseFloat(costUnit)) || "$0.00";
}



// WEBPACK FOOTER //
// ./app/lib/formatters/currency.js